module.exports = __webpack_public_path__ + "static/widget-img-18-d32386326edf070f478068ca852981aa.png";